/**
 * Calls handler once resolved
 * @param {string} selector
 * @param {function} handler
 * @param {number|null} maxTime - max time (in ms) to wait before executing. Defaults
 * to null for infinite
 */
export const intervalUntilExists = (
  selector: string,
  handler: Function,
  maxTime: number | null | undefined = undefined,
  pageDocument: Document | ShadowRoot = document
) => {
  const startTime = Date.now();
  const waitInt = setInterval(() => {
    const els = pageDocument.querySelectorAll(selector);
    if (
      els?.length > 0 ||
      (typeof maxTime === "number" && Date.now() - startTime >= maxTime)
    ) {
      clearInterval(waitInt);
      handler(els);
    }
  }, 250);
  return waitInt;
};

export const intervalUntilShadowElementExists = (
  shadowDom: HTMLElement,
  selector: string,
  handler: Function,
  maxTime: number | null | undefined = undefined
) => {
  const startTime = Date.now();
  const waitInt = setInterval(() => {
    const els = shadowDom.shadowRoot?.querySelectorAll(selector);
    if (
      els?.length > 0 ||
      (typeof maxTime === "number" && Date.now() - startTime >= maxTime)
    ) {
      clearInterval(waitInt);
      handler(els);
    }
  }, 250);
  return waitInt;
};

export default intervalUntilExists;
